import * as React from "react";
import { ParseQueryValues, EmptyQuery } from "helpers/queryFunctions";
import { IQuery } from "components/organisms/Menus/QueryMenu/QueryMenu";
import { apiFilter, apiFilterCount } from "api/new/filterApi";
import { INewsDisplay } from "api/types/NewsEntity";
import { definedRouteTypes } from "api/api";
import definedLocales from "locales/definedLocales";
import styled from "styled-components";
import IFrameHeader from "components/organisms/Menus/IFrameHeader";
import IframeEventsMap from "components/organisms/EventsMap/IframeMap";
import IFrameFooter from "components/organisms/MainFooter/IFrameFooter";
import { IQueryResult } from "components/organisms/QueryResult/QueryResult";
import withLocationAndLocale, {
  WithLocationAndLocaleProps,
} from "HoC/withLocationAndLocale";

import IframeFilter from "./QueryPages/IframeFilters";

import "../../iframe.css";

const StyledDiv = styled.div({
  minHeight: "85vh",
  margin: "2em",
  marginTop: "1em",
  overflowY: "hidden",
  overflowX: "hidden",
  // Because semantic marked it as important :(
  ".ui.stackable.grid": {
    marginLeft: "-1rem!important",
    marginRight: "-1rem!important",
  },
  "@media only screen and (max-width:320px)": {
    margin: "1em",
    marginTop: "1em",
    ".column": {
      paddingTop: "0.5rem!important",
      paddingBottom: "0.5rem!important",
    },
  },
});

export interface SimpleIframePageProps {
  location?: any;
  locale?: any;
}

export interface SimpleIframePageState {
  queryResult: INewsDisplay[];
  count: number;
  loading: boolean;
  query: IQuery;
  error: boolean;
  language: definedLocales;
  events: INewsDisplay[];
  mapView: boolean;
}

class SimpleIframePage extends React.Component<
  SimpleIframePageProps | WithLocationAndLocaleProps,
  SimpleIframePageState
> {
  state = {
    queryResult: [],
    count: 0,
    loading: true,
    error: false,
    query: EmptyQuery,
    language: definedLocales.latvian,
    events: [],
    mapView: false,
  };

  componentDidMount() {
    const { location, locale } = this.props;
    const searchQuery = location.search.substr(
      1,
      window.location.search.length,
    );
    const attributes = searchQuery?.split("&") || [];
    const query = ParseQueryValues(attributes);
    this.setState((prevState) => ({
      ...prevState,
      loading: true,
      error: false,
    }));
    let language = definedLocales.latvian;
    if (query.lng?.toUpperCase() === definedLocales.english) {
      language = definedLocales.english;
      locale.setLocale(definedLocales.english);
    }
    Promise.all([apiFilter(query), apiFilterCount(query)])
      .then(([resp, count]) => {
        this.setState((prevState) => ({
          ...prevState,
          queryResult: resp.items,
          events: resp.items.filter(
            (i: INewsDisplay) => i.type === definedRouteTypes.events,
          ),
          query,
          loading: false,
          count,
          language,
        }));
      })
      .catch(() => {
        this.setState((prevState) => ({
          ...prevState,
          query: EmptyQuery,
          loading: false,
          error: true,
        }));
      });
  }

  handleFilter = (query: IQuery) => {
    Promise.all([apiFilter(query)])
      .then(([resp]) => {
        this.setState((prevState) => ({
          ...prevState,
          queryResult: resp.items,
          query,
          loading: false,
        }));
      })
      .catch(() => {
        this.setState((prevState) => ({
          ...prevState,
          query: EmptyQuery,
          loading: false,
          error: true,
        }));
      });
  };

  handleNextPage = async (prev?: boolean) => {
    const { query } = this.state;
    const { offset, limit } = query;
    let accLimit: number = limit;
    if (prev) accLimit = -limit;
    let newOffset = offset + accLimit;
    let newLimit = accLimit;
    if (newOffset < 0) newOffset = 0;
    if (newLimit < 12) newLimit = limit;

    query.offset = newOffset;
    query.limit = newLimit;

    this.handleFilter(query);
  };

  render() {
    const {
      events,
      queryResult,
      mapView,
      loading,
      error,
      count,
      query,
    } = this.state;
    const { type, showAllRecords, offset, limit } = query;
    const newQueryResult: IQueryResult = {
      handleNextPage: this.handleNextPage,
      handlePrevPage: this.handleNextPage,
      loading,
      error,
      validQuery: true,
      events: queryResult,
      count,
      disableNextPage: offset + limit >= count,
      disablePrevPage: offset === 0,
      showAllRecords: showAllRecords === "true",
    };
    let onlyEvents = false;
    if (type && type.length > 0 && type[0] === definedRouteTypes.events) {
      onlyEvents = true;
    }
    return (
      <div>
        <StyledDiv>
          <IFrameHeader
            showMapButton={events.length > 0 || onlyEvents}
            mapView={mapView}
            toggleMapView={() =>
              this.setState((prevState) => ({
                ...prevState,
                mapView: !mapView,
              }))
            }
          />
          {mapView ? (
            <IframeEventsMap query={query} />
          ) : (
            <IframeFilter query={newQueryResult} onlyEvents={onlyEvents} />
          )}
        </StyledDiv>
        <IFrameFooter />
      </div>
    );
  }
}

export default withLocationAndLocale(SimpleIframePage);
